import React, { useEffect, useState } from 'react';
import './InsurancePaymentStep.scss';
import DynaDatePicker from "../../DynaView/DynaDatePicker";
import DynaInput from "../../DynaView/DynaInput";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import DynaButton from "../../DynaView/DynaButton";
import { toast } from "react-toastify";

const InsurancePaymentStep = ({ sendData, setSendData, paymentAmount, setPaymentAmount }) => {
  const [componentData, setComponentData] = useState({
    insurancePrice: "0",
    prePayment: "0",
    firstInternalDate: "",
    countInsurance: "1",
  });

  useEffect(() => {
    setComponentData({
      ...componentData,
      insurancePrice: sendData.insurancePrice === "" ? "0" : sendData.insurancePrice,
      prePayment: sendData.prePayment === "" ? "0" : sendData.prePayment,
      firstInternalDate: sendData.firstInternalDate === "" ? "" : sendData.firstInternalDate,
      countInsurance: sendData.countInsurance === "" ? "1" : sendData.countInsurance,
    });
  }, []);

  // محاسبه تخفیف و اضافه دریافتی
  useEffect(() => {
    if (sendData?.payType === "نقدی") {
      const insurancePrice = +componentData.insurancePrice;
      const currentPaymentAmount = +paymentAmount;

      let discount = 0;
      let extraReceived = 0;

      if (currentPaymentAmount > insurancePrice) {
        extraReceived = currentPaymentAmount - insurancePrice;
      } else if (currentPaymentAmount < insurancePrice) {
        discount = insurancePrice - currentPaymentAmount;
      }

      setSendData(prev => ({
        ...prev,
        customerOfferPrice: discount.toString(),
        customerReceivedExtra: extraReceived.toString()
      }));
    }
  }, [componentData.insurancePrice, paymentAmount, sendData?.payType]);

  const insuranceHandler = () => {
    if (componentData?.firstInternalDate === "") {
      return toast.error("تاریخ شروع قسط را وارد کنید");
    }

    if (componentData?.insurancePrice === "0") {
      return toast.error("مبلغ کل حق بیمه نمی تواند صفر باشد");
    }

    if (+componentData.prePayment > +componentData?.insurancePrice) {
      return toast.error("مبلغ پیش پرداخت باید کمتر از مبلغ کل حق بیمه باشد");
    }

    let temp = []
    let i = 0
    while (i < +componentData?.countInsurance) {
      if (i + 1 === +componentData?.countInsurance) {
        temp.push({
          caption: "قسط",
          price: (+componentData?.insurancePrice - +componentData?.prePayment) - (+sendData.eachInternalPrice * i),
          date: UtilsFunctions.addMonths(componentData.firstInternalDate, i)
        })
      } else {
        temp.push({
          caption: "قسط",
          price: sendData.eachInternalPrice,
          date: UtilsFunctions.addMonths(componentData.firstInternalDate, i)
        })
      }

      i = i + 1
    }
    setSendData({
      ...sendData, ...componentData,
      installmentDetails: temp,
      customerInsurancePrice: "",
      customerFirstInternalDate: "",
      customerCountInsurance: 1,
      customerReceivedPay: "",
      customerRealPay: "",
      customerInstallmentDetails: []
    });
  }

  useEffect(() => {
    setSendData({
      ...sendData,
      eachInternalPrice: Math.round((+componentData?.insurancePrice - +componentData?.prePayment) / +componentData?.countInsurance)
    })
  }, [componentData]);

  // تغییرات جدید در تاریخ 30 بهمن 1403
  useEffect(() => {
    if (sendData?.payType === "اقساط" && sendData.insurancePrice !== "0") {
      setSendData(prevState => ({ ...prevState, insurancePrice: "0" }));
    }
    if (sendData.payType === "نقدی" && sendData.insurancePrice === "0") {
      setSendData(prevState => ({ ...prevState, insurancePrice: componentData?.insurancePrice || prevState.insurancePrice }));
      // مقداردهی اولیه مبلغ واریزی برابر با مبلغ حق بیمه
      setPaymentAmount(componentData?.insurancePrice || "0");
    }
  }, [sendData?.payType]);

  return (
    <div className="insurance-payment">
      <div className={"grid-side"}>
        {/* تغییرات جدید در تاریخ 30 بهمن 1403 */}
        <div className="radio-buttons-container"
          style={{ gridColumn: "1 / -1", justifyContent: "flex-start" }}>
          <div className="radio-button">
            <label htmlFor="radio1" className="radio-button__label" style={{ padding: "0", fontWeight: "500" }}>
              نوع پرداخت :
            </label>
          </div>

          <div className='radio-buttons'>
            <div className="radio-button">
              <input name="radio-group1"
                id="radio1"
                className="radio-button__input"
                type="radio"
                checked={sendData?.payType === "اقساط"}
                onChange={() => setSendData({ ...sendData, payType: "اقساط" })} />
              <label htmlFor="radio1" className="radio-button__label">
                <span className="radio-button__custom"></span>
                اقساط
              </label>
            </div>

            <div className="radio-button">
              <input name="radio-group1"
                id="radio2"
                className="radio-button__input"
                type="radio"
                checked={sendData?.payType === "نقدی"}
                onChange={() => setSendData({ ...sendData, payType: "نقدی" })} />
              <label htmlFor="radio2" className="radio-button__label">
                <span className="radio-button__custom"></span>
                نقدی
              </label>
            </div>
          </div>
        </div>

        {/* نمایش فیلد مبلغ کل حق بیمه در هر دو حالت */}
        <div style={{ gridColumn: "1 / -1" }}>
          <DynaInput
            label={"مبلغ کل حق بیمه"}
            name={"insurancePrice"}
            className={"solid-dyna-input"}
            placeholder={"مبلغ کل حق بیمه را وارد کنید"}
            hasComma={true}
            value={UtilsFunctions.addCommas(componentData?.insurancePrice)}
            type={"text"}
            setDataFromComponent={(data) => {
              setComponentData({ ...componentData, ...data });
              if (sendData?.payType === "نقدی") {
                setPaymentAmount(data.insurancePrice || "0");
                setSendData(prev => ({
                  ...prev,
                  insurancePrice: data.insurancePrice || "0",
                  customerOfferPrice: "0",
                  customerReceivedExtra: "0"
                }));
              }
            }}
          />
        </div>

        {sendData?.payType === "نقدی" &&
          <>
            <div style={{ gridColumn: "1 / -1" }}>
              <DynaInput
                label={"مبلغ واریزی"}
                name={"paymentAmount"}
                className={"solid-dyna-input"}
                placeholder={"مبلغ واریزی را وارد کنید"}
                hasComma={true}
                value={UtilsFunctions.addCommas(paymentAmount)}
                type={"text"}
                setDataFromComponent={(data) => {
                  setPaymentAmount(data.paymentAmount || "0");
                }}
              />
            </div>

            <DynaInput label={"تخفیف"}
              name={"customerOfferPrice"}
              className={"solid-dyna-input"}
              placeholder={"تخفیف را وارد کنید"}
              hasComma={true}
              disabled
              value={UtilsFunctions.addCommas(sendData?.customerOfferPrice || "0")}
              type={"text"}
            />

            <DynaInput label={"اضافه دریافتی"}
              name={"customerReceivedExtra"}
              className={"solid-dyna-input"}
              placeholder={"تخفیف را وارد کنید"}
              hasComma={true}
              disabled
              value={UtilsFunctions.addCommas(sendData?.customerReceivedExtra || "0")}
              type={"text"}
            />
          </>
        }

        {/* نمایش بقیه ورودی‌ها فقط در صورت انتخاب "اقساط" */}
        {sendData?.payType === "اقساط" && (
          <>
            <DynaInput label={"مبلغ پیش پرداخت"}
              name={"prePayment"}
              className={"solid-dyna-input"}
              placeholder={"مبلغ پیش پرداخت را وارد کنید"}
              hasComma={true}
              value={UtilsFunctions.addCommas(componentData?.prePayment)}
              type={"text"}
              setDataFromComponent={(data) => {
                {
                  +data.prePayment <= +componentData?.insurancePrice ?
                    setComponentData({ ...componentData, ...data }) :
                    toast.error("مبلغ پیش پرداخت باید کمتر از مبلغ کل حق بیمه باشد")
                }
              }}
            />

            <DynaDatePicker label={"تاریخ شروع قسط"}
              name={"firstInternalDate"}
              className={"solid-dyna-input"}
              value={componentData?.firstInternalDate}
              setDataFromComponent={(data) => {
                setComponentData({ ...componentData, ...data })
              }}
            />

            <DynaInput label={"حداکثر تعداد اقساط"}
              name={"countInsurance"}
              className={"solid-dyna-input"}
              placeholder={"حداکثر تعداد اقساط را وارد کنید"}
              value={componentData?.countInsurance}
              type={"number"}
              setDataFromComponent={(data) => {
                {
                  data.countInsurance !== "" ? setComponentData({ ...componentData, ...data }) :
                    setComponentData({ ...componentData, countInsurance: "1" })
                }
              }}
            />

            <DynaInput label={"مبلغ هر قسط"}
              name={"eachInternalPrice"}
              className={"solid-dyna-input"}
              placeholder={"مبلغ هر قسط را وارد کنید"}
              hasComma={true}
              disabled
              value={UtilsFunctions.addCommas(sendData?.eachInternalPrice)}
              type={"text"}
            />

            <DynaButton className={"insurance-button"} type={"button"} onClick={insuranceHandler}>
              اعمال
            </DynaButton>
          </>
        )}
      </div>

      {sendData?.payType === "اقساط" && sendData?.installmentDetails.length > 0 && (
        <ul className={"list-box"}>
          {sendData?.installmentDetails.map((item, index) =>
            <li key={index + "J"}>
              <div className={"inline-text"}>
                <h3>{item?.caption + " " + (index + 1)}</h3>
                <h4>تاریخ :</h4>
                <h4>{(item?.date)}</h4>
              </div>
              <div className={"inline-text"}>
                <h4>مبلغ :</h4>
                <h4>{UtilsFunctions.addCommas(item?.price)}</h4>
              </div>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default InsurancePaymentStep;